import React from "react";
import { useStepper } from "../ui/stepper";
import { cn } from "../../lib/utils";
import { useMemo } from "react";

export const CompanionFormProgress = ({ children }) => {
  return (
    <div className="bg-background  border-b h-[var(--header-height)]">
      <div className="h-full w-full flex justify-between items-center  px-4 lg:px-24">
        {children}
      </div>
    </div>
  );
};
